import { useTranslation } from "react-i18next";

type ServiceSection = {
  title: string;
  paragraphs?: string[];
  intro?: string;
  list?: string[];
  intro2?: string;
  list2?: string[];
  tail?: string;
  tail2?: string;
  subsections?: Array<{
    title: string;
    paragraphs?: string[];
    intro?: string;
    list?: string[];
    tail?: string;
  }>;
};

export default function TermsOfService() {
  const { t } = useTranslation("auth");
  const { t: tCommon } = useTranslation("common");
  const { t: tTerms } = useTranslation("terms");
  const sections = tTerms("service.sections", { returnObjects: true }) as ServiceSection[];

  return (
    <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-foreground mb-2">{t("termsPageTitle")}</h1>
          <p className="text-muted-foreground text-lg">{t("legalSubtitle")}</p>
          <p className="text-muted-foreground">{t("lastUpdated")}: {tTerms("updatedAt")}</p>
        </div>

        <div className="prose prose-slate max-w-none space-y-8">
          {sections.map((section) => (
            <section key={section.title}>
              <h2 className="text-2xl font-bold text-foreground mb-4">{section.title}</h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="text-foreground mb-4">{paragraph}</p>
              ))}
              {section.intro && <p className="text-foreground mb-4">{section.intro}</p>}
              {section.list && (
                <ul className="list-disc list-inside text-foreground mb-4 space-y-1">
                  {section.list.map((item) => <li key={item}>{item}</li>)}
                </ul>
              )}
              {section.intro2 && <p className="text-foreground mb-4">{section.intro2}</p>}
              {section.list2 && (
                <ul className="list-disc list-inside text-foreground mb-4 space-y-1">
                  {section.list2.map((item) => <li key={item}>{item}</li>)}
                </ul>
              )}
              {section.subsections?.map((subsection) => (
                <div key={subsection.title}>
                  <h3 className="text-xl font-semibold text-foreground mt-4 mb-2">{subsection.title}</h3>
                  {subsection.paragraphs?.map((paragraph) => (
                    <p key={paragraph} className="text-foreground mb-4">{paragraph}</p>
                  ))}
                  {subsection.intro && <p className="text-foreground mb-4">{subsection.intro}</p>}
                  {subsection.list && (
                    <ul className="list-disc list-inside text-foreground mb-4 space-y-1">
                      {subsection.list.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                  )}
                  {subsection.tail && <p className="text-foreground mb-4">{subsection.tail}</p>}
                </div>
              ))}
              {section.tail && <p className="text-foreground mb-4">{section.tail}</p>}
              {section.tail2 && <p className="text-foreground">{section.tail2}</p>}
            </section>
          ))}
        </div>
      </main>

      <footer className="border-t py-8 mt-12">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          © 2026 Akuna. {tCommon("allRightsReserved")}.
        </div>
      </footer>
    </div>
  );
}
